export const contractAddress = "erd1qqqqqqqqqqqqqpgqljx7ahxgz60k5tn5h7rs94z9ukwudvgrstrqz3lhny";
export const dAppName = "LandBoard Presale";

export const whitelistDate = 1647280800000;
export const presaleDate = 1647367200000;
export const presaleEndDate = 1648663200000;
